import { SocialMessageType } from '@hooks/useWebsocketTypes';
import { FeedItemType, SubscriptionType } from 'types/feedTypes';
import { PostType } from 'types/postTypes';
import { ActionType, PayloadErrorType } from 'types/reduxTypes';
import { ForeignUserStoreType } from 'types/stateTypes';
import {
  CHANGE_SUBSCRIPTION,
  CHANGE_SUBSCRIPTION_FAILED,
  CHANGE_SUBSCRIPTION_SUCCESS,
  REQUEST_OWN_FEEDS,
  REQUEST_OWN_FEEDS_FAILED,
  REQUEST_OWN_FEEDS_SUCCESS,
  REQUEST_POSTS_BY_OWNER,
  REQUEST_POSTS_BY_OWNER_FAILED,
  REQUEST_POSTS_BY_OWNER_SUCCESS,
  REQUEST_SUBSCRIPTION,
  REQUEST_SUBSCRIPTION_FAILED,
  REQUEST_SUBSCRIPTION_SUCCESS,
  REQUEST_USER_NEWS,
  REQUEST_USER_NEWS_FAILED,
  REQUEST_USER_NEWS_SUCCESS,
  UPDATE_FEED_POST_REACTIONS,
  UPDATE_POST_STATS_WS,
  UPDATE_POST_WS,
  UPDATE_POST_WS_FAILED,
  UPDATE_POST_WS_SUCCESS,
} from '../constants';

export type RequestNewsPayloadType = {
  id?: string | null;
  mode: string;
  since?: string;
  forOffline?: boolean;
  pageSize?: number;
};

export type RequestPostsByUserType = {
  userId: string;
  since?: string;
  pageSize?: number;
};

export type AnswerNewsPayloadType = {
  data: FeedItemType[];
  mode: string;
  isBrowserOnline?: boolean;
  pageSize: number;
};

export type RequestSubscriptionsPayloadType = {
  id: string | null;
};

export type SubscriptionsPayloadType = {
  forOffline?: boolean;
  subscription?: SubscriptionType[];
};

export type ProfilePublicationsAnswerType = {
  publications: ForeignUserStoreType['publications'];
  pageSize: number;
};

export type UpdatePostWsActionType = {
  postId: string;
  actionType: 'update' | 'delete';
};

export type UpdatePostWsSuccessType = {
  post?: PostType;
  postId: UpdatePostWsActionType['postId'];
  actionType: UpdatePostWsActionType['actionType'];
};

export type ChangeSubscriptionPayloadType = { query?: QueryType; forOffline?: boolean; userId?: string | null };

type QueryType = { source: string; subscribed: boolean };

export type ChangedSubscriptionPayloadType = { query: QueryType; userId: string | null; forOffline?: boolean };

export function requestPostsByOwner(payload: RequestPostsByUserType): ActionType<unknown> {
  return {
    payload,
    type: REQUEST_POSTS_BY_OWNER,
  };
}

export function requestPostsByOwnerSuccess(payload: ProfilePublicationsAnswerType): ActionType<unknown> {
  return {
    payload,
    type: REQUEST_POSTS_BY_OWNER_SUCCESS,
  };
}

export function requestPostsByOwnerFailed(payload: PayloadErrorType): ActionType<unknown> {
  return {
    payload,
    type: REQUEST_POSTS_BY_OWNER_FAILED,
  };
}

export function requestUserNews(payload: RequestNewsPayloadType): ActionType<unknown> {
  return {
    payload,
    type: REQUEST_USER_NEWS,
  };
}

export function requestUserNewsSuccess(payload: AnswerNewsPayloadType): ActionType {
  return {
    payload,
    type: REQUEST_USER_NEWS_SUCCESS,
  };
}

export function requestUserNewsFailed(payload: PayloadErrorType): ActionType {
  return {
    payload,
    type: REQUEST_USER_NEWS_FAILED,
  };
}

export function requestSubscription(payload: RequestSubscriptionsPayloadType): ActionType {
  return {
    payload,
    type: REQUEST_SUBSCRIPTION,
  };
}

export function requestSubscriptionSuccess(payload: SubscriptionsPayloadType): ActionType {
  return {
    payload,
    type: REQUEST_SUBSCRIPTION_SUCCESS,
  };
}

export function requestSubscriptionFailed(payload: PayloadErrorType): ActionType {
  return {
    payload,
    type: REQUEST_SUBSCRIPTION_FAILED,
  };
}

export function changeSubscription(payload: ChangeSubscriptionPayloadType): ActionType {
  return {
    payload,
    type: CHANGE_SUBSCRIPTION,
  };
}

export function changeSubscriptionSuccess(payload: ChangedSubscriptionPayloadType): ActionType {
  return {
    payload,
    type: CHANGE_SUBSCRIPTION_SUCCESS,
  };
}

export function changeSubscriptionFailed(payload: PayloadErrorType): ActionType {
  return {
    payload,
    type: CHANGE_SUBSCRIPTION_FAILED,
  };
}

export function requestOwnFeeds(payload: unknown): ActionType {
  return {
    payload,
    type: REQUEST_OWN_FEEDS,
  };
}

export function requestOwnFeedsSuccess(payload: unknown): ActionType {
  return {
    payload,
    type: REQUEST_OWN_FEEDS_SUCCESS,
  };
}

export function requestOwnFeedsFailed(payload: PayloadErrorType): ActionType {
  return {
    payload,
    type: REQUEST_OWN_FEEDS_FAILED,
  };
}

export function updatePostStatsWs(payload: SocialMessageType): ActionType {
  return {
    payload,
    type: UPDATE_POST_STATS_WS,
  };
}

export function updatePostWs(payload: UpdatePostWsActionType): ActionType {
  return {
    payload,
    type: UPDATE_POST_WS,
  };
}

export function updatePostWsSuccess(payload: UpdatePostWsSuccessType): ActionType {
  return {
    payload,
    type: UPDATE_POST_WS_SUCCESS,
  };
}

export function updatePostWsFailed(payload: unknown): ActionType {
  return {
    payload,
    type: UPDATE_POST_WS_FAILED,
  };
}

export function updateFeedPostReactions(payload: string): ActionType {
  return {
    payload,
    type: UPDATE_FEED_POST_REACTIONS,
  };
}
